import React, { Component } from 'react';


class Step10 extends Component {

    render() {
        return (
            <div className="card card-body">
                <div className="row">
                    <div className="form-group">
                        <div className="h2">C3 Device Testing – Legend and Notes</div>
                    </div>
                </div>
                <div className="row">
                    <table className="table table-striped table-bordered">
                        <thead className='thead-dark'>
                            <tr>
                                <th scope="col" colSpan={2}>Device & Description</th>
                                {/* <th scope="col"></th> */}

                            </tr>
                            {/* <tr>
                                <th scope="col">Type</th>
                                <th scope="col">Model No.</th>
                            </tr> */}
                        </thead>
                        <tbody>
                            <tr>
                                <td scope="row pr-4">
                                    <label>FS - Sprinkler Flow Switch</label>
                                    <input type="text" className="form-control" id="typeFS" name="typeFS" placeholder="Type" />
                                </td>
                                <td scope="row">
                                    <label>&nbsp;</label>
                                    <input type="text" className="form-control" id="modelFS" name="modelFS" placeholder="Model No." />
                                </td>
                            </tr>
                            <tr>
                                <td scope="row pr-4">
                                    <label>SS - Sprinkler Supervisory device</label>
                                    <input type="text" className="form-control" id="typeSS" name="typeSS" placeholder="Type" />
                                </td>
                                <td scope="row">
                                    <label>&nbsp;</label>
                                    <input type="text" className="form-control" id="modelSS" name="modelSS" placeholder="Model No." />
                                </td>
                            </tr>
                            <tr>
                                <td scope="row pr-4">
                                    <label>LPS - Low Pressure Supervisory Devices</label>
                                    <input type="text" className="form-control" id="typeLPS" name="typeLPS" placeholder="Type" />
                                </td>
                                <td scope="row">
                                    <label>&nbsp;</label>
                                    <input type="text" className="form-control" id="modelLPS" name="modelLPS" placeholder="Model No." />
                                </td>
                            </tr>
                            <tr>
                                <td scope="row pr-4">
                                    <label>LWS - Low Water Supervisory Devices</label>
                                    <input type="text" className="form-control" id="typeLWS" name="typeLWS" placeholder="Type" />
                                </td>
                                <td scope="row">
                                    <label>&nbsp;</label>
                                    <input type="text" className="form-control" id="modelLWS" name="modelLWS" placeholder="Model No." />
                                </td>
                            </tr>
                            <tr>
                                <td scope="row pr-4">
                                    <label>LTS - Low Temperature Supervisory Devices</label>
                                    <input type="text" className="form-control" id="typeLTS" name="typeLTS" placeholder="Type" />
                                </td>
                                <td scope="row">
                                    <label>&nbsp;</label>
                                    <input type="text" className="form-control" id="modelLTS" name="modelLTS" placeholder="Model No." />
                                </td>
                            </tr>
                            <tr>
                                <td scope="row pr-4">
                                    <label>LPS Power Loss Supervisory Devices</label>
                                    <input type="text" className="form-control" id="typeLPS2" name="typeLPS2" placeholder="Type" />
                                </td>
                                <td scope="row">
                                    <label>&nbsp;</label>
                                    <input type="text" className="form-control" id="modelLPS2" name="modelLPS2" placeholder="Model No." />
                                </td>
                            </tr>
                            <tr>
                                <td scope="row pr-4">
                                    <label>Supervisory Devices</label>
                                    <input type="text" className="form-control" id="typeSUP1" name="typeSUP1" placeholder="Type" />
                                </td>
                                <td scope="row">
                                    <label>&nbsp;</label>
                                    <input type="text" className="form-control" id="modelSUP1" name="modelSUP1" placeholder="Model No." />
                                </td>
                            </tr>
                            <tr>
                                <td scope="row pr-4">
                                    <label>Supervisory Devices</label>
                                    <input type="text" className="form-control" id="typeSUP2" name="typeSUP2" placeholder="Type" />
                                </td>
                                <td scope="row">
                                    <label>&nbsp;</label>
                                    <input type="text" className="form-control" id="modelSUP2" name="modelSUP2" placeholder="Model No." />
                                </td>
                            </tr>
                            <tr>
                                <td scope="row pr-4">
                                    <label>Supervisory Devices</label>
                                    <input type="text" className="form-control" id="typeSUP3" name="typeSUP3" placeholder="Type" />
                                </td>
                                <td scope="row">
                                    <label>&nbsp;</label>
                                    <input type="text" className="form-control" id="modelSUP3" name="modelSUP3" placeholder="Model No." />
                                </td>
                            </tr>
                            <tr>
                                <td scope="row pr-4">
                                    <label>TAS - Signal Transmitting Unit Tamper Switch</label>
                                    <input type="text" className="form-control" id="typeTAS" name="typeTAS" placeholder="Type" />
                                </td>
                                <td scope="row">
                                    <label>&nbsp;</label>
                                    <input type="text" className="form-control" id="modelTAS" name="modelTAS" placeholder="Model No." />
                                </td>
                            </tr>
                            <tr>
                                <td scope="row pr-4">
                                    <label>FAC - Fire Alarm System Output Contact – Alarm</label>
                                    <input type="text" className="form-control" id="typeFAC" name="typeFAC" placeholder="Type" />
                                </td>
                                <td scope="row">
                                    <label>&nbsp;</label>
                                    <input type="text" className="form-control" id="modelFAC" name="modelFAC" placeholder="Model No." />
                                </td>
                            </tr>
                            <tr>
                                <td scope="row pr-4">
                                    <label>FTC - Fire Alarm System Output Contact – Trouble</label>
                                    <input type="text" className="form-control" id="typeFTC" name="typeFTC" placeholder="Type" />
                                </td>
                                <td scope="row">
                                    <label>&nbsp;</label>
                                    <input type="text" className="form-control" id="modelFTC" name="modelFTC" placeholder="Model No." />
                                </td>
                            </tr>
                            <tr>
                                <td scope="row pr-4">
                                    <label>FSC - Fire Alarm System Output Contact –</label>
                                    <input type="text" className="form-control" id="typeFSC" name="typeFSC" placeholder="Type" />
                                </td>
                                <td scope="row">
                                    <label>&nbsp;</label>
                                    <input type="text" className="form-control" id="modelFSC" name="modelFSC" placeholder="Model No." />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
};

export default Step10;



// WEBPACK FOOTER //
// ./src/components/Step10.js